import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LogoutButton = ({show}) => {
  const { logout } = useAuth0();

  return (
    <>
    {show ? null : 
    <button
      className="btn btn-primary btn-block"
      onClick={() => logout({ returnTo: window.location.origin })}
    >
      Log Out
    </button>
    }
    </>
  );
};

export default LogoutButton;
